import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MapPin, Phone, Sailboat } from "lucide-react";
export default function MasterTheBay() {
  return <section data-section-id="183635" id="your-vessel-refined" className="dark bg-background text-foreground relative min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="w-full lg:w-[45%] relative min-h-[50vh] lg:min-h-screen shrink-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634081/img/luxury_yacht_detailing.png" alt="Luxury yacht gliding through deep blue water" className="absolute inset-0 w-full h-full object-cover rounded-none" />
        {}
        <div className="absolute inset-0 bg-black/40 lg:bg-transparent lg:bg-gradient-to-r lg:from-black/40 lg:to-background/90 pointer-events-none" />
      </div>

      {}
      <div className="w-full lg:w-[55%] relative flex flex-col justify-center px-6 py-32 lg:px-16 xl:px-24 z-10">
        {}
        <div className="absolute inset-0 opacity-5 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634081/img/nautical_chart_pattern.png)] bg-cover bg-center mix-blend-overlay pointer-events-none" />

        <div className="relative z-10 max-w-2xl">
          {}
          <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 border border-primary/30 bg-primary/10 text-primary uppercase tracking-widest text-xs font-bold rounded-sm">
            <Sailboat className="size-3.5" />
            <span className="font-default">Precision Marine Detailing</span>
          </div>

          {}
          <h1 className="font-default font-bold text-[32px] md:text-[56px] text-white tracking-tight mb-6 uppercase leading-tight">
            Your Vessel, Refined.
          </h1>
          
          <p className="text-muted-foreground text-base md:text-lg mb-12 leading-relaxed font-default max-w-xl">
            Expert boat detailing services designed for luxury and longevity. We restore your vessel to showroom condition with marine-grade precision and dockside care.
          </p>

          {}
          <div className="flex flex-col gap-8 mb-12 p-8 border border-border bg-card/50 backdrop-blur-md rounded-sm">
            <div className="flex items-start sm:items-center gap-5 flex-col sm:flex-row">
              <div className="flex items-center justify-center size-14 bg-primary text-primary-foreground shrink-0 rounded-sm shadow-lg">
                <Phone className="size-6" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground uppercase tracking-widest mb-1 font-semibold font-default">
                  Service Request
                </p>
                <p className="text-3xl font-bold text-foreground font-default tracking-tighter">(773)410-1234</p>
              </div>
            </div>
            
            <div className="h-px w-full bg-border" />
            
            <div className="flex items-center gap-4 text-muted-foreground">
              <MapPin className="size-5 text-primary shrink-0" />
              <span className="text-sm uppercase tracking-wider font-medium font-default">
                Premium Mobile Service & Dockside Care
              </span>
            </div>
          </div>

          {}
          <div className="flex flex-wrap gap-4">
            <Link to="#">
              <Button size="lg" className="rounded-sm font-bold tracking-widest uppercase bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-8 shadow-xl transition-all">
                Instant Quote
              </Button>
            </Link>
            <Link to="#">
              <Button size="lg" variant="outline" className="rounded-sm font-bold tracking-widest uppercase border-white text-white hover:bg-white hover:text-background h-14 px-8 transition-all">
                Explore Gallery
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}